<template>
  <q-dialog
    ref="dialog"
    @hide="onDialogHide"
  >
    <q-card class="q-dialog-plugin">
      <terms-and-conditions class="article-terms" />
      <q-card-actions align="right">
        <q-btn
          @click="onOKClick"
          color="primary"
          label="OK"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>
import TermsAndConditions from '@/helpers/terms-and-conditions.md';

export default {
  components: {
    TermsAndConditions,
  },
  props: {},
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    },

    onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok');
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide();
    },
    onCancelClick() {
      // we just need to hide dialog
      this.hide();
    },
  },
};
</script>
<style lang="scss">
.article-terms {
  padding: 10px 5px;
  h1 {
    margin: 0;
    font-size: 30px;
    font-weight: bold;
    line-height: 1.2em;
    text-align: center;
  }
  h2 {
    margin: 0;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.2em;
    & + * {
      margin-top: 0.5em;
    }
  }
  hr {
    & + * {
      margin-top: 1em;
    }
  }
  p + p {
    margin-top: 1em;
  }
  p + hr {
    margin-top: 1em;
  }
}
</style>
